import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, ElementRef, HostListener, OnInit, OnChanges, SimpleChanges, OnDestroy, signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { ApiService } from '../../../services/api.service';
import { TruncatePipe } from '../../../pipes/truncate.pipe';
import QRCode from 'qrcode';
import { ToastService } from '../../../services/toast.service';
import { Web3ServiceService } from '../../../services/web3-service.service';
import { WalletService } from '../../../services/wallet.service';
import { WholeNumberOnlyDirective } from '../../directives/whole-number.directive';
import { Web2ServiceService } from '../../../services/web2-service.service';
import { ethers } from 'ethers';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../../../services/local-storage.service';

@Component({
  selector: 'app-deposit-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, TruncatePipe, WholeNumberOnlyDirective],
  templateUrl: './deposit-modal.component.html',
  styleUrl: './deposit-modal.component.css'
})
export class DepositModalComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<void>();
  currentView: 'main' | 'transfer' | 'card' | 'paypal' | 'processing' | 'completed' | 'transak' = 'main';
  transakUrl = signal<SafeResourceUrl | null>(null);
  depositAmount: string = '';
  isListOpen = false;
  isChainOpen = false;
  userData: any;
  qrCodeDataUrl: string = '';
  usdcBalance: any = '0.00';
  depositSubscription?: Subscription;
  private portfolioGlobalSubscription?: Subscription;

  currencies = [
    // { code: 'BTC', icon: 'btc.svg' },
    { code: 'USDC', icon: 'usdc.svg' },
    // { code: 'ARB', icon: 'arb.svg' },
    // { code: 'BNB', icon: 'bnb.svg' },
    // { code: 'BTCB', icon: 'btc.svg' },
    // { code: 'BUSD', icon: 'busd.svg' },
  ];
  selectedCurrency = this.currencies[0];
  chains = [
    { name: 'Polygon', icon: 'polygon.svg' },
    // { name: 'Bitcoin', icon: 'btc.svg' },
    // { name: 'USDC', icon: 'usdc.svg' },
    // { name: 'ARB', icon: 'arb.svg' },
    // { name: 'BNB', icon: 'bnb.svg' },
    // { name: 'BTCB', icon: 'btc.svg' },
    // { name: 'BUSD', icon: 'busd.svg' },
  ];
  selectedChain = this.chains[0];
  parseFloat: any;
  isTransakProcessing = signal<boolean>(false);
  isDepositProcessing = signal<boolean>(false);

  constructor(private el: ElementRef,
    private auth: AuthService,
    private api: ApiService,
    private toast: ToastService,
    private web3Service: Web3ServiceService,
    private walletService: WalletService,
    private web2Service: Web2ServiceService,
    private sanitizer: DomSanitizer,
    private localStorageService: LocalStorageService
  ) { }


  ngOnInit(): void {
    this.loadUserData();
    // const address = this.walletService.getAddress();
    // console.log("Address..................:", address);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']?.currentValue === true) {
      this.loadUserData();
    }
  }

  private loadUserData(): void {
    this.userData = this.auth.getUserData();
    if (this.userData?.id) {
      // Generate QR code using the proxy_wallet address already available in the local state,
      // eliminating the need for a redundant getUserProfile API call.
      if (this.userData.proxy_wallet) {
        this.generateQrCode(this.userData.proxy_wallet);
      }

      // Subscribe to the global stream managed by AuthService
      if (this.portfolioGlobalSubscription) this.portfolioGlobalSubscription.unsubscribe();
      this.portfolioGlobalSubscription = this.auth.portfolioSummary$.subscribe({
        next: (res: any) => {
          if (!res) return;
          // console.log("Deposit Modal UI Update from Global Stream:", res);
          // cash_balance from the stream is the ground truth
          this.usdcBalance = res.cash_balance ?? res.data?.cash_balance ?? this.usdcBalance;
        }
      });
    }
  }

  /**
   * Get user profile
   * @param userId 
   */
  getProfileData(userId: any) {
    this.api
      .getUserProfile(userId)
      .subscribe(async (result: any) => {
        this.userData = result.data;
        this.generateQrCode(this.userData.proxy_wallet);
      });
  }

  // Local stream removed - now using global stream from AuthService


  /**
   * Generate QR code
   * @param address 
   */
  generateQrCode(address: string) {
    if (address) {
      // console.log('Generating QR code for address:', address);
      QRCode.toDataURL(address, { width: 250, margin: 1 })
        .then(url => {
          this.qrCodeDataUrl = url;

          // console.log('Generated QR code:', url);
        })
        .catch(err => {
          console.error('Error generating QR code', err);
        });
    }
  }
  close() {
    this.closeModal.emit();
    this.resetToMain();
  }
  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.isListOpen = !this.isListOpen;
  }
  selectCurrency(item: any) {
    this.selectedCurrency = item;
    this.isListOpen = false;
  }
  toggleChainDropdown(event: Event) {
    event.stopPropagation();
    this.isChainOpen = !this.isChainOpen;
  }

  selectChain(item: any) {
    this.selectedChain = item;
    this.isChainOpen = false;
  }
  @HostListener('document:click', ['$event'])
  closeOnOutsideClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.current-value-dropdown')) {
      this.isListOpen = false;
      this.isChainOpen = false;
    }
  }

  openTransferCrypto() {
    this.currentView = 'transfer';
  }

  openDepositWithCard() {
    this.currentView = 'card';
    this.depositAmount = ''; // Reset amount when switching to card view
  }

  openDepositWithPaypal() {
    this.currentView = 'paypal';
    this.depositAmount = ''; // Reset amount when switching to paypal view
  }

  goBack() {
    this.currentView = 'main';
  }

  public async handleDeposit() {
    if (this.isDepositProcessing()) return;
    this.isDepositProcessing.set(true);

    try {
      // Get wallet address from service or profile, avoiding problematic JSON.parse on raw strings
      let wallet = this.walletService.getAddress() || this.userData?.public_address;

      if (!wallet) {
        this.toast.error("Wallet address not found. Please reconnect.");
        this.isDepositProcessing.set(false);
        return;
      }

      const balance = await this.web3Service.getUSDCBalance(wallet);

      const depositedAmount = Number(this.depositAmount);

      if (depositedAmount > Number(balance)) {
        this.toast.error("Insufficient USDC balance");
        this.isDepositProcessing.set(false);
        return;
      }

      if (depositedAmount <= 0 || isNaN(depositedAmount)) {
        this.toast.error("Please enter a valid amount");
        this.isDepositProcessing.set(false);
        return;
      }

      // Common Trading Enablement Check
      if (!this.userData?.enable_trading) {
        this.auth.sendOperationSignal("enable-trading");
        this.isDepositProcessing.set(false);
        return;
      }

      this.currentView = 'processing';

      let txHash = '';
      if (this.userData.user_type === 'WEB2') {
        const tx = {
          to: this.userData.proxy_wallet,
          value: ethers.parseEther(this.depositAmount),
          gasLimit: 21000,
        };
        const signedTx = await this.web2Service.signTransaction(tx);
        console.log("Signed TX (WEB2):", signedTx);
        txHash = signedTx;
      } else {
        const tx = await this.web3Service.transferUSDC(this.userData.proxy_wallet, depositedAmount);
        if (!tx) {
          this.toast.error("Transaction failed. Please try again.");
          this.currentView = 'main';
          this.isDepositProcessing.set(false);
          return;
        }
        console.log("Transaction successful (WEB3):", tx);
        txHash = tx?.hash || tx;
      }

      // Unified Backend Sync and Pre-approval flow
      this.api.depositFunds(this.userData.id, parseFloat(this.depositAmount), txHash).subscribe({
        next: async (res: any) => {
          console.log("Backend deposit record success:", res);

          try {
            // Handle Pre-Approval regardless of user type
            if (res.data?.requires_approval && res.data?.safe_transaction) {
              await this.processPreApproval(res.data.safe_transaction);
            }

            this.openCompleted();
            this.auth.reUpdateProfile(true);
          } catch (err: any) {
            console.error("Error during pre-approval:", err);
            // Handle error logic here if needed
          } finally {
            this.isDepositProcessing.set(false);
          }
        },
        error: (err: any) => {
          console.error("Backend deposit record failed:", err);
          this.openCompleted();
          this.auth.reUpdateProfile(true);
          this.isDepositProcessing.set(false);
        }
      });
    } catch (error: any) {
      console.error("Deposit failed:", error);
      const errorMsg = error?.message?.toLowerCase() || '';
      
      if (error?.code === 4001 || errorMsg.includes('user denied') || errorMsg.includes('rejected') || errorMsg.includes('user cancelled')) {
        this.toast.error("Transaction was cancelled by user.");
      } else if (error?.code === 'INSUFFICIENT_FUNDS' || errorMsg.includes('insufficient funds') || errorMsg.includes('intrinsic transaction cost')) {
        this.toast.error("Insufficient POL for gas fees.");
      } else {
        this.toast.error(error?.message || "Deposit failed. Please try again.");
      }
      this.currentView = 'main';
      this.isDepositProcessing.set(false);
    }
  }

  public async handleTransakDeposit() {
    console.log("Transak Deposit Initialized. Current UserData:", this.userData);

    if (!this.userData?.id) {
      console.error("No user ID found in session");
      this.toast.error('User session not found. Please log in and try again.');
      return;
    }

    if (!this.userData?.enable_trading) {
      console.log("Trading enablement required. Sending signal...");
      this.auth.sendOperationSignal("enable-trading");
      return;
    }

    this.isTransakProcessing.set(true);
    console.log(`Calling depositFunds for user ${this.userData.id} (Type: ${this.userData.user_type})...`);
    this.api.depositFunds(this.userData.id, 0).subscribe({
      next: async (res) => {
        console.log("depositFunds Response:", res);

        try {
          if (res.data?.requires_approval && res.data?.safe_transaction) {
            console.log("Approval required. Initializing signing flow...");
            await this.processPreApproval(res.data.safe_transaction);
            console.log("Pre-approval signing completed successfully.");
            // After successful pre-approval, trigger transak
            console.log("Pre-approval successful. Triggering Transak session...");
            this.getTransakSession();
          } else {
            console.log("No approval required. Triggering Transak session...");
            this.getTransakSession();
          }
        } catch (err: any) {
          console.error("Error during pre-approval processing:", err);
          const errorMsg = err?.message?.toLowerCase() || '';
          if (err?.code === 4001 || errorMsg.includes('user denied') || errorMsg.includes('rejected') || errorMsg.includes('user cancelled')) {
            this.toast.error("Transaction was cancelled by user.");
          } else {
            this.toast.error("An error occurred during pre-approval. Please try again.");
          }
          this.currentView = 'main'; // Revert view on error
          this.isTransakProcessing.set(false);
        }
      },
      error: (err) => {
        console.error("depositFunds API Error:", err);
        this.toast.error("Something went wrong. Please try again.");
        this.currentView = 'main';
        this.isTransakProcessing.set(false);
      }
    });
  }

  private async getTransakSession() {
    console.log("Requesting Transak session URL...");
    this.api.getTransakSession(this.userData.id).subscribe({
      next: (res) => {
        console.log("Transak Session API Response:", res);
        if (res.data?.widget_url) {
          console.log("Opening Transak Widget in iframe:", res.data.widget_url);
          const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.widget_url);
          this.transakUrl.set(safeUrl);
          this.currentView = 'transak';
          this.isTransakProcessing.set(false);

          // Start monitoring for successful deposit
          console.log("Starting real-time deposit stream monitoring...");
          this.depositSubscription = this.api.streamUserDeposits(this.userData.id).subscribe({
            next: (data) => {
              console.log("Real-time deposit update received:", data);
              this.toast.success("Deposit processed successfully!");
              this.auth.reUpdateProfile(true);
              this.openCompleted();

              // Stop monitoring once success is received
              this.depositSubscription?.unsubscribe();
            },
            error: (err) => {
              console.warn("Deposit stream error (this is common for idle connections):", err);
            }
          });
        } else {
          console.warn("No widget_url returned from Transak API.");
          this.isTransakProcessing.set(false);
        }
      },
      error: (err) => {
        console.error("Transak session error:", err);
        this.toast.error("Failed to start Transak session");
        this.isTransakProcessing.set(false);
      }
    });
  }

  private async processPreApproval(safeTx: any) {
    // console.log("processPreApproval started with safeTx:", safeTx);
    try {
      const chainId = 80002;
      let signature;

      // Define standard Gnosis Safe types
      const types = {
        SafeTx: [
          { name: 'to', type: 'address' },
          { name: 'value', type: 'uint256' },
          { name: 'data', type: 'bytes' },
          { name: 'operation', type: 'uint8' },
          { name: 'safeTxGas', type: 'uint256' },
          { name: 'baseGas', type: 'uint256' },
          { name: 'gasPrice', type: 'uint256' },
          { name: 'gasToken', type: 'address' },
          { name: 'refundReceiver', type: 'address' },
          { name: 'nonce', type: 'uint256' }
        ]
      };

      // Helper to ensure valid address strings (40 chars)
      const ensureAddress = (addr: string) => (addr && addr !== '0x0') ? addr : '0x0000000000000000000000000000000000000000';

      const message = {
        to: ensureAddress(safeTx.to),
        value: safeTx.value || 0,
        data: safeTx.data || '0x',
        operation: safeTx.operation || 0,
        safeTxGas: safeTx.safe_tx_gas || 0,
        baseGas: safeTx.base_gas || 0,
        gasPrice: safeTx.gas_price_param || 0,
        gasToken: ensureAddress(safeTx.gas_token),
        refundReceiver: ensureAddress(safeTx.refund_receiver),
        nonce: safeTx.nonce || 0
      };

      if (this.userData.user_type?.toUpperCase() === 'WEB2') {
        const meta = await this.web2Service.getUserMetaData();
        const safeAddress = this.userData.proxy_wallet;

        const signingAddress = meta?.publicAddress || this.userData.public_address;
        // console.log("Executing Web2 Signature with Metadata Address:", signingAddress);

        if (!safeAddress || safeAddress === '0x0') {
          console.error("Invalid proxy wallet address for domain:", safeAddress);
          throw new Error("Signature failed: Proxy wallet address not assigned yet.");
        }

        if (!signingAddress || signingAddress === '0x0') {
          throw new Error("Signature failed: No valid signing address found from provider.");
        }

        const payload = {
          domain: {
            chainId: Number(chainId),
            verifyingContract: safeAddress,
          },
          types: {
            EIP712Domain: [
              { name: 'chainId', type: 'uint256' },
              { name: 'verifyingContract', type: 'address' }
            ],
            ...types
          },
          primaryType: 'SafeTx',
          message: message
        };

        // console.log("Full Payload for Magic Sign:", JSON.stringify(payload, null, 2));
        signature = await this.web2Service.signTypedData(signingAddress, payload);
        // console.log("Magic EIP-712 Signature Result:", signature);
      } else {
        // console.log("Processing Web3 (Wagmi) signature...");
        const account = this.walletService.getAccount();

        const payload = {
          domain: {
            chainId: account.chainId,
            verifyingContract: this.userData.proxy_wallet,
          },
          types: types,
          primaryType: 'SafeTx',
          message: message
        };

        signature = await this.walletService.signTypedData(payload);
      }

      if (signature) {
        // console.log("Signature generated successfully, preparing broadcast...");
        const executePayload = {
          ...safeTx,
          signature: signature
        };

        return new Promise((resolve, reject) => {
          this.api.executePreApproval(this.userData.id, executePayload).subscribe({
            next: (res) => {
              console.log("Execute Pre-approval Success:", res);
              resolve(res);
            },
            error: (err) => {
              console.error("Execute Pre-approval Error:", err);
              reject(err);
            }
          });
        });
      } else {
        throw new Error("Signature generation failed or was cancelled.");
      }
    } catch (err) {
      console.error("Critical Error in processPreApproval:", err);
      throw err;
    }
  }

  openCompleted() {
    this.currentView = 'completed';
    this.toast.success("Deposit successful");
    setTimeout(() => {
      this.close();
    }, 3000);
  }

  resetToMain() {
    this.currentView = 'main';
    this.depositAmount = '';
    this.isListOpen = false;
    this.isDepositProcessing.set(false);
    this.isTransakProcessing.set(false);
  }

  setAmount(amount: string) {
    this.depositAmount = amount.replace('$', '');
  }

  copyText(): void {
    navigator.clipboard.writeText(this.userData.proxy_wallet).then(() => {
      this.toast.success("Address copied successfully");
    });
  }

  ngOnDestroy(): void {
    if (this.portfolioGlobalSubscription) {
      this.portfolioGlobalSubscription.unsubscribe();
    }
  }
}